import React, { Component } from 'react'
import { Container, Row, Col, Navbar, Button } from 'reactstrap'
import { NavLink } from 'react-router-dom'
import './Navigation.css'
import logo from '../logo.svg'
import type { AppInfo } from '../contexts/AppsContext'

interface HeaderComponentProps {
  theme: 'light' | 'dark'
  onToggleTheme: () => void
  coreApps: AppInfo[]
}

interface HeaderComponentState {
  isNavOpen: boolean
  isSpinning: boolean
}

class HeaderComponent extends Component<HeaderComponentProps, HeaderComponentState> {
  constructor(props: HeaderComponentProps) {
    super(props)
    this.state = {
      isNavOpen: false,
      isSpinning: false,
    }
    this.toggleNav = this.toggleNav.bind(this)
    this.handleLogoDoubleClick = this.handleLogoDoubleClick.bind(this)
  }

  toggleNav() {
    this.setState({
      isNavOpen: !this.state.isNavOpen,
    })
  }

  handleLogoDoubleClick() {
    this.setState({ isSpinning: true })
    // Reset spinning state after animation completes (1 second)
    setTimeout(() => {
      this.setState({ isSpinning: false })
    }, 1000)
  }

  render() {
    return (
      <div className="header">
        <Container>
          <Row>
            <Col onDoubleClick={this.handleLogoDoubleClick}>
              <img src={logo} alt="logo" className={`App-logo ${this.state.isSpinning ? 'App-logo-spin-once' : ''}`} />
            </Col>
            <Col className="page-title">
              <h2>QA Report Portal</h2>
            </Col>
          </Row>
          <Row>
            <Col>
              <Navbar expand="md" container={false} className="nav-container">
                <div className="nav-tabs">
                  <NavLink to="/dashboard" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                    <Button className="nav-button">Status Dashboard</Button>
                  </NavLink>
                  {this.props.coreApps.map(app => (
                    <NavLink
                      key={app.key}
                      to={`/reports/${app.key}`}
                      className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                    >
                      <Button className="nav-button">{app.label} Reports</Button>
                    </NavLink>
                  ))}
                  <NavLink to="/additional" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                    <Button className="nav-button">Additional Services</Button>
                  </NavLink>
                </div>
                <button
                  type="button"
                  role="switch"
                  aria-checked={this.props.theme === 'dark'}
                  className={`theme-switch ${this.props.theme === 'dark' ? 'is-dark' : ''}`}
                  onClick={this.props.onToggleTheme}
                  aria-label={this.props.theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
                  title={this.props.theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
                >
                  <span className="theme-switch-thumb">
                    {this.props.theme === 'dark' ? (
                      <svg viewBox="0 0 24 24" width="12" height="12" fill="currentColor" aria-hidden="true">
                        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
                      </svg>
                    ) : (
                      <svg
                        viewBox="0 0 24 24"
                        width="12"
                        height="12"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        aria-hidden="true"
                      >
                        <circle cx="12" cy="12" r="4" />
                        <line x1="12" y1="1" x2="12" y2="3" />
                        <line x1="12" y1="21" x2="12" y2="23" />
                        <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
                        <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
                        <line x1="1" y1="12" x2="3" y2="12" />
                        <line x1="21" y1="12" x2="23" y2="12" />
                        <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
                        <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
                      </svg>
                    )}
                  </span>
                </button>
              </Navbar>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default HeaderComponent
